"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setState = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const setState = exports.setState = (0, _actionGenerator.actionGenerator)(_types.EStateActionTypes.SetState);